import React, { useRef, useState } from "react";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const LONG_PRESS_DELAY_MS = 650;

export default function PdfReportMenuItem({
  onOpen,
  onRegenerate,
  onClose,
  label = "PDF Report",
  regenerateLabel = "Force Regenerate PDF",
  icon = <ReceiptLongIcon />,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const longPressTimerRef = useRef(null);
  const suppressClickRef = useRef(false);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    if (suppressClickRef.current) {
      event.preventDefault();
      event.stopPropagation();
      suppressClickRef.current = false;
      return;
    }

    onClose?.();
    onOpen?.(event);
  };

  const clearLongPressTimer = () => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current);
      longPressTimerRef.current = null;
    }
  };

  const startLongPress = (event) => {
    const target = event.currentTarget;
    clearLongPressTimer();
    longPressTimerRef.current = setTimeout(() => {
      suppressClickRef.current = true;
      setAnchorEl(target);
    }, LONG_PRESS_DELAY_MS);
  };

  const handleOptionsClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const handleRegenerate = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
    onClose?.();
    onRegenerate?.(event);
  };

  return (
    <>
      <MenuItem
        onClick={handleOpen}
        onMouseDown={startLongPress}
        onMouseUp={clearLongPressTimer}
        onMouseLeave={clearLongPressTimer}
        onTouchStart={startLongPress}
        onTouchEnd={clearLongPressTimer}
      >
        <ListItemIcon>
          {icon}
        </ListItemIcon>
        <ListItemText primary={label} />
      </MenuItem>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleOptionsClose}
        anchorOrigin={{ vertical: "center", horizontal: "right" }}
        transformOrigin={{ vertical: "center", horizontal: "left" }}
      >
        <MenuItem onClick={handleRegenerate}>{regenerateLabel}</MenuItem>
      </Menu>
    </>
  );
}
